<template>
    <base-modal ref="baseModal" @resetform="resetForm()" :load-data="loadData" :send="send" :valid-form="isValid">
        <template v-slot:header>
            <h3 v-if="isNewCall">{{$t('make_call_title')}}</h3>
            <h3 v-if="isTransfer">{{$t('transfer_call_title')}}</h3>
        </template>

        <div class="form-group">
            <label>{{$t('number_title')}}:</label>
            <input required class="form-control" v-model="number" />
        </div>
    </base-modal>

</template>

<script>
import BaseModal from "./BaseModal";
import {AgentService} from "../services/agent-service";
import "../vee-validate";

export default {
	props: {agentService: AgentService, action: String, call: Object},
	data: () => ({number: ""}),
	components: {BaseModal},
	computed: {
		isValid() {
			return this.number != "";
		},
		isNewCall() {
			return !this.action || this.action == "new-call";
		},
		isTransfer() {
			return this.action == "transfer";
		}
	},
	methods: {
		async open() {
			this.$refs.baseModal.open();
		},
		resetForm() {
			this.number = "";
		},
		async loadData() {},
		send() {
			return this.isTransfer ? this.sendTransfer() : this.sendMakeCall();
		},
		sendMakeCall() {
			return this.agentService
				.makeCall({
					func: "call",
					number: this.number
				}).then(res => {
					// console.info(res);
					return res == "ok" ? "ok" : false;
				});
		},
		sendTransfer() {
			let transferData = {
				callId: this.call.callid,
				number: this.number,
				isOutgoingCall: this.call.outgoing
			};
			// console.info("CALL", this.call); return Promise.resolve(false);
			return this.agentService.transferCall(transferData)
				.then(res => res == "ok" ? "ok" : false);
		}
	}
};
</script>